/*! yuno-behavior.js v1 (Yuno 2026-09-24). Section-level shopper behavior for PostHog, same file on every brand.
 * Loads after posthog.init() in the layout <head>, deferred. Sends, per page view:
 *   section_viewed   first time a section fills the screen: which sections people reach, in what order, how fast
 *   cta_clicked      add to cart, buy now, bundle bar, checkout, cart, FAQ, reviews, gallery, video, links, tagged
 *                    with the section they were in
 *   video_progress   play (user-started), 25/50/75%, complete, unmute
 *   page_engagement  on leave: time on page, active time, max scroll, per-section dwell and scroll speed, scroll-backs,
 *                    and the section on screen when they left
 * Every event carries the product it belongs to (product_id, product_handle, product_title): the product page's
 * product, a landing page's buy-box product, and for clicks the product of the buy box that was clicked. Nothing is
 * stored as a persistent person property, so one product never leaks into another page's events.
 * It also writes _ph_did / _ph_sid cart attributes once per session so orders can be joined to sessions.
 * Never reads typed input or personal data: headings and button labels only.
 * Optional naming: data-track-section="Name" on a section, data-track="Name" on a button (otherwise Shopify section
 * ids, headings and button labels are used).
 * Debug: add ?yb_debug=1 to a URL to log every event in the console.
 */
(function () {
  "use strict";
  var W = window, D = document;
  if (W.__yb || !D.querySelectorAll || !D.addEventListener) return;
  W.__yb = 1;

  var DEBUG = /[?&]yb_debug=1/.test(location.search);
  var TICK = 400, IDLE = 20000;
  var T0, PV, S, focus, activeAt, activeMs, maxPct, firstScroll, backs, lastDir, lastY, lastTick, ctaCount, atc,
    lastSentKey;

  function reset() {
    T0 = Date.now(); PV = T0.toString(36) + Math.random().toString(36).slice(2, 7);
    S = []; focus = null; activeAt = T0; activeMs = 0; maxPct = 0; firstScroll = 0; backs = 0; lastDir = 0;
    lastY = W.pageYOffset || 0; lastTick = T0; ctaCount = 0; atc = false; lastSentKey = ""; PROD = null;
  }
  reset();

  var meta = (W.ShopifyAnalytics && W.ShopifyAnalytics.meta) || {};
  var PAGE = (meta.page && meta.page.pageType) || "";
  var PROD = null;
  function formProduct(root) {                                // product id of a buy box (Dawn and most themes)
    var f = root && root.querySelector && root.querySelector('form[action*="/cart/add"] [name="product-id"],[data-product-id]');
    return f ? (f.getAttribute("value") || f.getAttribute("data-product-id") || "") : "";
  }
  function pageProduct() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/), p = meta.product;
    if (p && p.id) {
      var v = (p.variants && p.variants[0]) || {}, t = (v.name || "").replace(v.public_title ? " - " + v.public_title : "", "");
      return { product_id: String(p.id), product_handle: m ? m[1] : null, product_title: t || null };
    }
    var id = formProduct(D);                                  // landing page: the product its buy box sells
    return id ? { product_id: String(id), product_handle: null, product_title: null } : null;
  }

  function cap(ev, props, beacon) {
    try {
      props.pv = PV; props.page_type = PAGE;
      if (PROD === null) PROD = pageProduct() || false;
      if (PROD && props.product_id === undefined) {
        props.product_id = PROD.product_id; props.product_handle = PROD.product_handle; props.product_title = PROD.product_title;
      }
      if (DEBUG && W.console) console.log("[yb]", ev, props);
      var p = W.posthog;
      if (p && p.capture) p.capture(ev, props, beacon ? { transport: "sendBeacon" } : undefined);
    } catch (e) { /* the tracker never breaks the page */ }
  }
  function txt(el, n) { return ((el && (el.innerText || el.textContent)) || "").replace(/\s+/g, " ").trim().slice(0, n || 60); }
  function r1(ms) { return Math.round(ms / 100) / 10; }
  function scrollPct() {
    var h = Math.max(D.documentElement.scrollHeight, D.body ? D.body.scrollHeight : 0) || 1;
    return Math.min(100, Math.round(((W.pageYOffset || 0) + W.innerHeight) / h * 100));
  }

  // ---------- sections ----------
  var SEL = "[data-track-section],.shopify-section,[data-lp-section]";
  function nameOf(el) {
    var t = el.getAttribute("data-track-section") || el.getAttribute("data-lp-section");
    if (t) return t.slice(0, 60);
    var m = (el.id || "").match(/__(.+)$/);
    if (!m) return "";
    var k = m[1], suf = k.match(/_([A-Za-z0-9]{6})$/);
    if (suf && /[A-Z0-9]/.test(suf[1])) k = k.slice(0, -7);   // Shopify's random instance suffix, e.g. _nGpg9a
    return /^\d/.test(k) ? "" : k;                             // numeric ids carry no meaning
  }
  function isFixed(el) {
    var p = W.getComputedStyle(el).position;
    if (p === "fixed" || p === "sticky") return true;
    return !!(el.firstElementChild && W.getComputedStyle(el.firstElementChild).position === "fixed");
  }
  function parts(el) {                                          // children of a very tall single-section page
    var c = el;
    for (var d = 0; d < 4 && c.children.length === 1; d++) c = c.children[0];
    var out = [];
    for (var i = 0; i < c.children.length; i++) {
      if (c.children[i].getBoundingClientRect().height >= 150) out.push(c.children[i]);
    }
    return out;
  }
  function entry(el, name) {
    for (var k = 0; k < S.length; k++) if (S[k].el === el) return S[k];
    return { el: el, name: name, label: txt(el.querySelector("h1,h2,h3,[data-track-heading]"), 70),
      seen: 0, dwell: 0, px: 0, t: 0 };
  }
  function scan() {
    try {
      var els = D.querySelectorAll(SEL), vh = W.innerHeight, next = [];
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.parentElement && el.parentElement.closest(SEL)) continue;          // outermost only
        if (el.getBoundingClientRect().height < 60 || isFixed(el)) continue;     // popups, sticky bars
        var nm = nameOf(el), sub = el.getBoundingClientRect().height > vh * 2.5 ? parts(el) : [];
        if (sub.length >= 3) {
          for (var j = 0; j < sub.length; j++) {
            next.push(entry(sub[j], sub[j].getAttribute("data-track-section") || ((nm || "section") + "." + (j + 1))));
          }
        } else next.push(entry(el, nm));
      }
      if (!next.length) {                                        // custom page without Shopify sections
        var root = D.querySelector("main") || D.body, kids = root ? root.children : [];
        for (var q = 0; q < kids.length; q++) {
          if (kids[q].getBoundingClientRect().height >= 150) next.push(entry(kids[q], "block." + (q + 1)));
        }
      }
      S = next;
      for (var n = 0; n < S.length; n++) S[n].i = n;
    } catch (e) { /* keep the previous list */ }
  }
  function label(s) { return s ? (s.name || s.label || "#" + s.i) : null; }
  function sectionOf(node) {
    for (var i = 0; i < S.length; i++) if (S[i].el.contains(node)) return S[i];
    return focus;
  }

  // ---------- the clock: reach, focus, dwell, speed ----------
  function tick() {
    var now = Date.now(), dt = now - lastTick;
    lastTick = now;
    if (D.visibilityState && D.visibilityState !== "visible") return;
    try {
      var y = W.pageYOffset || 0, dy = y - lastY;
      lastY = y;
      if (dy && !firstScroll) firstScroll = now - T0;
      if (Math.abs(dy) > 40) {
        var dir = dy > 0 ? 1 : -1;
        if (lastDir && dir !== lastDir) backs++;
        lastDir = dir;
      }
      var pct = scrollPct();
      if (pct > maxPct) maxPct = pct;
      var vh = W.innerHeight, mid = vh / 2, f = null;
      for (var i = 0; i < S.length; i++) {
        var s = S[i], r = s.el.getBoundingClientRect();
        if (!s.seen && r.height > 0 && r.top < vh * 0.8 && r.bottom > vh * 0.2) {
          s.seen = now - T0;
          cap("section_viewed", { sec_i: s.i, sec: label(s), sec_label: s.label, n_sec: S.length, scroll_pct: pct,
            t_s: r1(s.seen) });
        }
        if (!f && r.top <= mid && r.bottom > mid) f = s;
      }
      focus = f || focus;
      var live = now - activeAt < IDLE && dt < TICK * 3;
      if (live) activeMs += dt;
      if (f && live) { f.dwell += dt; f.t += dt; f.px += Math.abs(dy); }
    } catch (e) { /* ignore */ }
  }
  function touch() { activeAt = Date.now(); }

  // ---------- clicks ----------
  var CTA = [
    ["add_to_cart", 'button[name="add"],[data-add-to-cart],.product-form__submit,form[action*="/cart/add"] [type="submit"],[class*="add-to-cart"],[class*="addtocart"],[class*="AddToCart"],[id*="AddToCart"]'],
    ["buy_now", ".shopify-payment-button,.shopify-payment-button__button,[data-shopify=\"payment-button\"]"],
    ["checkout", '[name="checkout"],a[href*="/checkout"],.cart__checkout-button,[class*="checkout-button"]'],
    ["bundle", "kaching-bundle,kaching-bundles-block,[class*=\"kaching-bundles__\"],[class*=\"bundle-option\"],[class*=\"bundle__\"]"],
    ["cart_open", 'a[href$="/cart"],[data-cart-toggle],[aria-controls*="cart"],[class*="cart-icon"]'],
    ["menu", 'header summary,header [aria-expanded],[class*="header"] [aria-expanded],[class*="menu-drawer"] summary'],
    ["faq", 'summary,[aria-expanded],[class*="question"],[class*="accordion"],[class*="collapsible"],[class*="faq-item"],[class*="faq__item"]'],
    ["reviews", '[class*="jdgm"],[class*="review"],[id*="review"]'],
    ["gallery", '[class*="thumbnail"],[class*="slider-button"],[class*="gallery"],[class*="media-toggle"],[data-media-id]'],
    ["video", "video"],
    ["link", "a[href]"],
    ["button", "button,[role=\"button\"],input[type=\"submit\"]"]
  ];
  function onClick(ev) {
    try {
      var t = ev.target;
      if (!t || !t.closest) return;
      var named = t.closest("[data-track]"), type = null, el = null;
      for (var i = 0; i < CTA.length && !el; i++) { el = t.closest(CTA[i][1]); if (el) type = CTA[i][0]; }
      if (!el && !named) {                                       // custom clickable (tabs, swatches, cards)
        for (var up = t, d = 0; up && up !== D.body && d < 4; up = up.parentElement, d++) {
          if (W.getComputedStyle(up).cursor === "pointer") { el = up; type = "tap"; break; }
        }
        if (!el) return;
      }
      var text = "";
      if (type === "bundle" && ev.composedPath) {                // Kaching renders bars inside a shadow root
        var path = ev.composedPath();
        for (var k = 0; k < path.length && !text; k++) {
          var n = path[k];
          if (n && n.getAttribute && /bar|deal|option|tier/i.test(n.getAttribute("class") || "")) text = txt(n, 80);
        }
      }
      var href = el && el.getAttribute && el.getAttribute("href");
      if (href) { try { href = new URL(href, location.href).pathname; } catch (e) { href = ""; } }
      var s = sectionOf(t), form = t.closest('form[action*="/cart/add"]') || t.closest("[data-product-id]");
      var clickedId = form ? (formProduct(form) || form.getAttribute("data-product-id") || "") : "";
      ctaCount++;
      if (type === "add_to_cart" || type === "buy_now") atc = true;
      cap("cta_clicked", { cta: named ? named.getAttribute("data-track") : type, cta_type: type || "named",
        cta_text: text || txt(named || el, 60), href: href || null, sec_i: s ? s.i : null, sec: label(s),
        scroll_pct: scrollPct(), t_s: r1(Date.now() - T0),
        product_id: clickedId || (PROD ? PROD.product_id : null),
        product_handle: clickedId && (!PROD || clickedId !== PROD.product_id) ? null : (PROD ? PROD.product_handle : null),
        product_title: clickedId && (!PROD || clickedId !== PROD.product_id) ? null : (PROD ? PROD.product_title : null) });
    } catch (e) { /* ignore */ }
  }

  // ---------- videos ----------
  function vcap(v, action) {
    var s = sectionOf(v), src = (v.currentSrc || v.src || "").split("?")[0].split("/").pop();
    cap("video_progress", { action: action, video: src.slice(0, 60), autoplay: !!v.autoplay, sec_i: s ? s.i : null,
      sec: label(s), t_s: r1(Date.now() - T0) });
  }
  function hookVideos() {
    var vs = D.getElementsByTagName("video");
    for (var i = 0; i < vs.length; i++) (function (v) {
      if (v.__yb) return;
      v.__yb = {};
      var bg = v.autoplay && v.muted && v.loop;                  // background loops count only when unmuted
      v.addEventListener("play", function () { if (!bg && !v.__yb.play) { v.__yb.play = 1; vcap(v, "play"); } });
      v.addEventListener("volumechange", function () { if (!v.muted && !v.__yb.unmute) { v.__yb.unmute = 1; vcap(v, "unmute"); } });
      v.addEventListener("timeupdate", function () {
        if ((bg && !v.__yb.unmute) || !v.duration || !isFinite(v.duration)) return;
        var q = Math.floor(v.currentTime / v.duration * 4) * 25;
        if (q >= 25 && q < 100 && !v.__yb[q]) { v.__yb[q] = 1; vcap(v, q + "%"); }
      });
      v.addEventListener("ended", function () { if (!v.__yb.done) { v.__yb.done = 1; vcap(v, "complete"); } });
    })(vs[i]);
  }

  // ---------- leaving ----------
  function summary(final) {
    try {
      var out = [], dw = 0;
      for (var i = 0; i < S.length; i++) {
        var s = S[i];
        dw += s.dwell;
        if (!s.seen && !s.dwell) continue;
        out.push({ i: s.i, sec: label(s), seen_s: r1(s.seen), dwell_s: r1(s.dwell),
          speed: s.t > 500 ? Math.round(s.px / (s.t / 1000)) : null });
      }
      var key = Math.round(dw / 1000) + ":" + maxPct + ":" + ctaCount;
      if (key === lastSentKey) return;                           // nothing new since the last send
      lastSentKey = key;
      cap("page_engagement", { total_s: r1(Date.now() - T0), active_s: r1(activeMs), max_scroll_pct: maxPct,
        first_scroll_s: firstScroll ? r1(firstScroll) : null, scroll_backs: backs, n_sec: S.length, sections: out,
        exit_sec: label(focus), exit_sec_i: focus ? focus.i : null, exit_scroll_pct: scrollPct(), cta_clicks: ctaCount,
        atc: atc, final: !!final }, true);
    } catch (e) { /* ignore */ }
  }

  // ---------- cart attributes: join orders to sessions ----------
  var tries = 0;
  function attrs() {
    try {
      var p = W.posthog;
      if (!p || !p.__loaded || !p.get_session_id) { if (++tries < 15) setTimeout(attrs, 2000); return; }
      var sid = p.get_session_id(), did = p.get_distinct_id(), k = "yb_attr_" + sid;
      if (!sid || !did || !W.sessionStorage || W.sessionStorage.getItem(k)) return;
      W.fetch("/cart/update.js", { method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ attributes: { _ph_did: did, _ph_sid: sid } }) })
        .then(function (r) { if (r.ok) W.sessionStorage.setItem(k, "1"); })["catch"](function () {});
    } catch (e) { /* storage blocked: skip */ }
  }

  // ---------- start ----------
  function start() {
    scan();
    hookVideos();
    setInterval(tick, TICK);
    setTimeout(function () { scan(); hookVideos(); }, 2500);     // lazy-loaded sections and videos
    setTimeout(function () { scan(); hookVideos(); }, 8000);
    if (W.fetch) setTimeout(attrs, 3000);
    setTimeout(summary, 20000);                                  // in-app browsers can close without a leave event
    setTimeout(summary, 60000);
    tick();
    if (DEBUG) W.__ybDebug = { sections: function () { return S; }, summary: summary };
  }
  var opt = { passive: true, capture: true };
  ["scroll", "touchstart", "mousemove", "keydown", "wheel"].forEach(function (e) { W.addEventListener(e, touch, opt); });
  D.addEventListener("click", function (ev) { touch(); onClick(ev); }, true);
  D.addEventListener("visibilitychange", function () { if (D.visibilityState === "hidden") summary(false); });
  W.addEventListener("pagehide", function () { summary(true); });
  W.addEventListener("pageshow", function (e) { if (e.persisted) { reset(); scan(); } });    // back/forward cache
  if (D.readyState === "loading") D.addEventListener("DOMContentLoaded", start); else start();
})();
